import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import Button, { TYPES } from '../Button/index'
import { dismissModal } from '../../services/dialog/actions'
import { URL_ACCOUNT_MAIN } from '../../services/url/constants'
import { selectAuth } from '../../services/auth/index'
import { historyRedirect } from '../../services/navigation/index'
import { selectUserLanguages } from '../../services/user/index'
import { H2, H3, HEADING_TYPES } from '../Heading/index'
import { selectStaticTextByKey } from '../../services/static-text/selectors'
import {
  MODAL_GIFT_PERIOD_NOTIFICATION_STATIC_KEY as staticTextStoreKey,
} from './modal-gift-period-notification-static-key'

export default function ModalGiftPeriodNotification ({ giftDaysRemaining, history }) {
  const auth = useSelector(selectAuth)
  const userLanguage = useSelector(selectUserLanguages)
  const staticText = useSelector(selectStaticTextByKey(staticTextStoreKey))

  const dispatch = useDispatch()

  const title = staticText.get('title')
  const subTitle = staticText.get('subTitle')
  const bodyText = giftDaysRemaining === 0
    ? staticText.get('zeroDayBody')
    : staticText.get('body').replace('{giftDaysRemaining}', giftDaysRemaining)

  const handleClose = () => {
    dispatch(dismissModal())
  }

  const handleSubscribe = () => {
    historyRedirect({
      history, url: URL_ACCOUNT_MAIN, auth, language: userLanguage,
    })
  }

  return (
    <div className="modal-gift-period-notification">
      <H2 as={HEADING_TYPES.H4}>{title}</H2>
      <H3 as={HEADING_TYPES.H4}>{subTitle}</H3>
      <div>{bodyText}</div>
      <div className="modal-gift-period-notification__buttons">
        <Button
          className="modal-confirm__cancel"
          type={TYPES.SECONDARY}
          onClick={handleClose}
        >
          {staticText.get('cancel')}
        </Button>
        <Button
          className="modal-confirm__continue"
          type={TYPES.PRIMARY}
          onClick={handleSubscribe}
        >
          {staticText.get('confirm')}
        </Button>
      </div>
    </div>
  )
}

ModalGiftPeriodNotification.propTypes = {
  giftDaysRemaining: PropTypes.number.isRequired,
  history: PropTypes.object.isRequired,
}
